import { observer } from "mobx-react";
import React, { useContext } from "react";

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { LiveStatus } from "@gp/models";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";

export default observer(function RemoveAllFavoritesEventsButton() {
	const favoritesStore = useContext(FavoritesStoreContext);
	const { t } = useTranslation();
	const location = useLocation();

	if (!favoritesStore) {
		return null;
	}
	if (
		!location.pathname.includes("my-favorites/events") ||
		favoritesStore.prematchFavoritesCount == 0
	) {
		return null;
	}

	return (
		<div className="pagination__remove">
			<button
				className="pagination__remove__btn btn btn--sml btn--ghost--danger"
				type="button"
				onClick={() =>
					favoritesStore.deselectFavoritesEvents(LiveStatus.PREMATCH)
				}
			>
				{t("FAVORITES.REMOVE_ALL_FAVORITES")}
			</button>
		</div>
	);
});
